import { configFetch as fetch } from '@laigu/utils';

export const speechToTxtApi = message_id => {
  return fetch({
    url: '/unified-api/conversations/v1/asr',
    method: 'post',
    data: {
      message_id
    }
  });
};
